'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propEnhancers = exports.propValidators = exports.propAliases = exports.propNames = exports.propTypes = exports.transition = exports.transform = exports.text = exports.spacing = exports.position = exports.overflow = exports.opacity = exports.list = exports.layout = exports.interaction = exports.grid = exports.flex = exports.dimensions = exports.boxShadow = exports.borders = exports.borderRadius = exports.background = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _background = require('./background');

var background = _interopRequireWildcard(_background);

var _borderRadius = require('./border-radius');

var borderRadius = _interopRequireWildcard(_borderRadius);

var _borders = require('./borders');

var borders = _interopRequireWildcard(_borders);

var _boxShadow = require('./box-shadow');

var boxShadow = _interopRequireWildcard(_boxShadow);

var _dimensions = require('./dimensions');

var dimensions = _interopRequireWildcard(_dimensions);

var _flex = require('./flex');

var flex = _interopRequireWildcard(_flex);

var _grid = require('./grid');

var grid = _interopRequireWildcard(_grid);

var _interaction = require('./interaction');

var interaction = _interopRequireWildcard(_interaction);

var _layout = require('./layout');

var layout = _interopRequireWildcard(_layout);

var _list = require('./list');

var list = _interopRequireWildcard(_list);

var _opacity = require('./opacity');

var opacity = _interopRequireWildcard(_opacity);

var _overflow = require('./overflow');

var overflow = _interopRequireWildcard(_overflow);

var _position = require('./position');

var position = _interopRequireWildcard(_position);

var _spacing = require('./spacing');

var spacing = _interopRequireWildcard(_spacing);

var _text = require('./text');

var text = _interopRequireWildcard(_text);

var _transform = require('./transform');

var transform = _interopRequireWildcard(_transform);

var _transition = require('./transition');

var transition = _interopRequireWildcard(_transition);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

exports.background = background;
exports.borderRadius = borderRadius;
exports.borders = borders;
exports.boxShadow = boxShadow;
exports.dimensions = dimensions;
exports.flex = flex;
exports.grid = grid;
exports.interaction = interaction;
exports.layout = layout;
exports.list = list;
exports.opacity = opacity;
exports.overflow = overflow;
exports.position = position;
exports.spacing = spacing;
exports.text = text;
exports.transform = transform;
exports.transition = transition;

var propTypes = exports.propTypes = _extends({}, background.propTypes, borderRadius.propTypes, borders.propTypes, boxShadow.propTypes, dimensions.propTypes, flex.propTypes, grid.propTypes, interaction.propTypes, layout.propTypes, list.propTypes, opacity.propTypes, overflow.propTypes, position.propTypes, spacing.propTypes, text.propTypes, transform.propTypes, transition.propTypes);

var propNames = exports.propNames = Object.keys(propTypes);

var propAliases = exports.propAliases = _extends({}, background.propAliases, borderRadius.propAliases, borders.propAliases, boxShadow.propAliases, dimensions.propAliases, flex.propAliases, grid.propAliases, interaction.propAliases, layout.propAliases, list.propAliases, opacity.propAliases, overflow.propAliases, position.propAliases, spacing.propAliases, text.propAliases, transform.propAliases, transition.propAliases);

var propValidators = exports.propValidators = _extends({}, background.propValidators, borderRadius.propValidators, borders.propValidators, boxShadow.propValidators, dimensions.propValidators, flex.propValidators, grid.propValidators, interaction.propValidators, layout.propValidators, list.propValidators, opacity.propValidators, overflow.propValidators, position.propValidators, spacing.propValidators, text.propValidators, transform.propValidators, transition.propValidators);

var propEnhancers = exports.propEnhancers = _extends({}, background.propEnhancers, borderRadius.propEnhancers, borders.propEnhancers, boxShadow.propEnhancers, dimensions.propEnhancers, flex.propEnhancers, grid.propEnhancers, interaction.propEnhancers, layout.propEnhancers, list.propEnhancers, opacity.propEnhancers, overflow.propEnhancers, position.propEnhancers, spacing.propEnhancers, text.propEnhancers, transform.propEnhancers, transition.propEnhancers);